import React, { useEffect, useState } from "react";
import { BaseUrl } from "../../config";

import { HeroText } from '../../components/';
import { HugeText } from '../../components/';
import { NumbersRowSingle } from '../../components/';
import { NumbersRowDouble } from '../../components/';
import { NumbersWrap } from '../../components/';
import { NumberCell } from '../../components/';
import { NumbersCol } from '../../components/';
import { NumberColImage } from '../../components/';
import { PeopleGridWrap } from '../../components/';
import { TimelineWrap } from '../../components';
import { HalfColText } from '../../components';
import { HalfColTextFlex } from '../../components';
import { RowQuotes } from '../../components';
import { RowAwards } from '../../components';
import { Banner } from '../../components';
import { Loader } from '../../components';

const CompanyContainer = () => {
  const [quotesArray, setQuotesArray] = useState([]);
  const [timelineArray, setTimelineArray] = useState([]);
  
  const awardsArray = [
    {
      "awardTitle": "Popai Awards Paris 2021",
      "awardNames": ["Digital, visual immersion"],
    },
    {
      "awardTitle": "Retail Institute Award 2019",
      "awardNames": ["Digital Engagement and Pure Digital", "Best in Show"],
    },
    {
      "awardTitle": "Prix Laval Virtual 2018",
      "awardNames": ["Business, Communication & Services"],
    },
    {
      "awardTitle": "Italian Popai Award 2016",
      "awardNames": ["Technological Innovation, In-store technology", "Best in Show", "Critics’ Choice"],
    }
  ]

  const heroImg = require('../../assets/company/hero-studio-alto_2880x2160.jpg');
  const numImgBig = require('../../assets/company/number_col_company.jpg');
  const numImgSmall = require('../../assets/company/box-small-employee_748x748.jpg');
  const imgParallax1 = require('../../assets/company/popai.png');
  const imgParallax2 = require('../../assets/company/oculus.png'); 
  const imgParallax3 = require('../../assets/company/inizio.png');

  const arrayLoad = [
    heroImg,
    numImgBig,
    numImgSmall,
    imgParallax1,
    imgParallax2,
    imgParallax3
  ]


  useEffect(() => {
    document.title = "Meet Invrsion"
    fetch(`${BaseUrl}/feedbacks?key=invrsion`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((json) =>  {
      setQuotesArray(json.data.feedbacks);
    })

    fetch(`${BaseUrl}/page?key=invrsion&slug=company`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((json) =>  {
      
      setTimelineArray(json.data.company.timeline);
    })
    
  }, [])
  return (
    <React.Fragment>
      
        <section className="company">
          <HeroText 
            title="Follow our journey through Full Reality" 
            paragraph="We are a company focused on virtual reality solutions; our goal is to provide our B2B clients the best experience, for themselves and their customers, through Full Reality." 
            textBelow={true} 
            image={heroImg}
          />
          <HugeText 
            title="It all started in 2015" 
            text="When Matteo Esposito, Flora Caroli, Paolo Pascolo and Luca Ferrari Trecate founded Invrsion, they thought to bring something that was related only to gaming and fun to other contexts. The founders believed in this project where VR would be a platform for building the future of the shopping experience." 
            align="left"
            bigTextClass={true}
            srcImg={imgParallax2}
          />
          <HugeText 
            title="First projects and honors" 
            text="After the first round of investments in 2016, we became involved in many projects with Auchan, Henkel and Pomellato and we were awarded at the Popai Awards. We participated in the Walmart Lab as the only Italian company selected, among the three European companies." 
            align="right"
            bigTextClass={false}
            srcImg={imgParallax1}
          />
          <HugeText
            title="Changing the world through Full Reality"
            text="Today, we have helped numerous businesses and companies grow by developing our very own technological house blend of VR/AR (and all those other tech acronyms), creating what we call Full Reality: our innovative tool that allows us to enhance experiences to the fullest."
            align="left"
            srcImg={imgParallax3}
            bigTextClass={false}
          />
          {
            timelineArray.length > 0  &&
            <TimelineWrap timelineArray={timelineArray}/>

          }
          
          <NumbersWrap>
            <h4 className="md--title">By the numbers</h4>
            <NumbersRowSingle>
              <NumberCell 
                isImage={false} 
                bigNumber="27" 
                size="" 
                title="Employees" 
                text="actively pushing e-commerce to new immersive frontiers"
              />
              <NumberCell 
                isImage={true} 
                image={numImgSmall}
              />
            </NumbersRowSingle>
            <NumbersRowDouble>
              <NumbersCol isImage={true}>
                <NumberColImage 
                  image={numImgBig}
                />
              </NumbersCol>
              <NumbersCol isImage={false}>
                <NumberCell 
                  isImage={false} 
                  isColumn={true}
                  bigNumber="4.5" 
                  size="M" 
                  title="Total Funding Amount" 
                  text="from 3 different funding rounds"
                />
                <NumberCell 
                  isImage={false} 
                  isColumn={true}
                  bigNumber="45" 
                  size="" 
                  title="Clients" 
                  text="who are already on board and trust in Invrsion’s solutions"
                />
              </NumbersCol>
            </NumbersRowDouble>
          </NumbersWrap>

          <PeopleGridWrap></PeopleGridWrap>
          <HalfColText >
            <div className="title--col">
              
            </div>
            {
              quotesArray.length > 0 &&
              <HalfColTextFlex>
                {
                  quotesArray.map((key, index) => {
                    return <RowQuotes key={index} quote={key.quote} name={key.name} company={key.company} position={key.company_role} />
                  })
                }
              </HalfColTextFlex>
            }
          </HalfColText>
          <HalfColText >
            <div className="title--col">
              <h6 className="big--title">
                Awards
              </h6>
            </div>
            <HalfColTextFlex>
              <p className="preset-9 intro--text">
                We're proud to be recognized for our daily engagement towards our mission:
              </p>
              {
                awardsArray.map((key, index) => {
                  return <RowAwards key={index} awardTitle={key.awardTitle} awards={key.awardNames} />
                })
              }
            </HalfColTextFlex>
          </HalfColText>
          <Banner 
            text="Intrigued? Let’s have a chat." route="/contact" copyRoute="Reach out" 
          />
        </section>
        <Loader arrayLoad={arrayLoad} />
      
    </React.Fragment>
  );
};

export default CompanyContainer;
